import { IconsProps } from '@/types/shared'

const NotificationOffIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M11.3049 21.75C12.4049 21.75 13.3049 20.85 13.3049 19.75H9.30493C9.30493 20.85 10.2049 21.75 11.3049 21.75ZM11.3049 6.25C13.7949 6.25 15.3049 8.27 15.3049 10.75V10.85L17.3049 12.85V10.75C17.3049 7.68 15.6749 5.11 12.8049 4.43V3.75C12.8049 2.92 12.1349 2.25 11.3049 2.25C10.4749 2.25 9.80493 2.92 9.80493 3.75V4.43C9.56493 4.49 9.33493 4.58 9.11493 4.66L10.7549 6.3C10.9349 6.28 11.1149 6.25 11.3049 6.25ZM4.71493 3.1L3.30493 4.51L6.11493 7.32C5.59493 8.32 5.30493 9.49 5.30493 10.75V15.75L3.30493 17.75V18.75H17.5449L19.2849 20.49L20.6949 19.08L4.71493 3.1ZM15.3049 16.75H7.30493V10.75C7.30493 10.07 7.42493 9.43 7.64493 8.85L15.3049 16.51V16.75Z"
                    fill="currentColor"
                />
            </svg>
        </div>
    )
}

export default NotificationOffIcons
